import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.IN.enumeration<
    ents.extra.rate.gl.Filter.Comparison.Operator,
    graphql.schema.GeneralLedgerFilterComparisonOperator
  >({
    [ents.extra.rate.gl.Filter.Comparison.Operator.Contains]:
      graphql.schema.GeneralLedgerFilterComparisonOperator.Contains,
    [ents.extra.rate.gl.Filter.Comparison.Operator.EndsWith]:
      graphql.schema.GeneralLedgerFilterComparisonOperator.Ends,
    [ents.extra.rate.gl.Filter.Comparison.Operator.Equals]:
      graphql.schema.GeneralLedgerFilterComparisonOperator.Eq,
    [ents.extra.rate.gl.Filter.Comparison.Operator.GreaterThan]:
      graphql.schema.GeneralLedgerFilterComparisonOperator.Greater,
    [ents.extra.rate.gl.Filter.Comparison.Operator.GreaterThanOrEqualTo]:
      graphql.schema.GeneralLedgerFilterComparisonOperator.GreaterEq,
    [ents.extra.rate.gl.Filter.Comparison.Operator.LessThan]:
      graphql.schema.GeneralLedgerFilterComparisonOperator.Less,
    [ents.extra.rate.gl.Filter.Comparison.Operator.LessThanOrEqualTo]:
      graphql.schema.GeneralLedgerFilterComparisonOperator.LessEq,
    [ents.extra.rate.gl.Filter.Comparison.Operator.NotEquals]:
      graphql.schema.GeneralLedgerFilterComparisonOperator.Neq,
    [ents.extra.rate.gl.Filter.Comparison.Operator.StartsWith]:
      graphql.schema.GeneralLedgerFilterComparisonOperator.Starts,
  }),
  graphql.transformers.OUT.enumeration<
    graphql.schema.GeneralLedgerFilterComparisonOperator,
    ents.extra.rate.gl.Filter.Comparison.Operator
  >({
    [graphql.schema.GeneralLedgerFilterComparisonOperator.Contains]:
      ents.extra.rate.gl.Filter.Comparison.Operator.Contains,
    [graphql.schema.GeneralLedgerFilterComparisonOperator.Ends]:
      ents.extra.rate.gl.Filter.Comparison.Operator.EndsWith,
    [graphql.schema.GeneralLedgerFilterComparisonOperator.Eq]:
      ents.extra.rate.gl.Filter.Comparison.Operator.Equals,
    [graphql.schema.GeneralLedgerFilterComparisonOperator.Greater]:
      ents.extra.rate.gl.Filter.Comparison.Operator.GreaterThan,
    [graphql.schema.GeneralLedgerFilterComparisonOperator.GreaterEq]:
      ents.extra.rate.gl.Filter.Comparison.Operator.GreaterThanOrEqualTo,
    [graphql.schema.GeneralLedgerFilterComparisonOperator.Less]:
      ents.extra.rate.gl.Filter.Comparison.Operator.LessThan,
    [graphql.schema.GeneralLedgerFilterComparisonOperator.LessEq]:
      ents.extra.rate.gl.Filter.Comparison.Operator.LessThanOrEqualTo,
    [graphql.schema.GeneralLedgerFilterComparisonOperator.Starts]:
      ents.extra.rate.gl.Filter.Comparison.Operator.StartsWith,
    [graphql.schema.GeneralLedgerFilterComparisonOperator.Neq]:
      ents.extra.rate.gl.Filter.Comparison.Operator.NotEquals,
  }),
)
